module.exports = {
      id: "8d6717baf63440595c493ed2a9d0b22broofShape-flat.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#8d6717baf63440595c493ed2a9d0b22broofShape-flat.svg",
      toString: function () {
        return this.url;
      }
    }